import { Component, OnInit } from '@angular/core';
import * as fromStore from "../../../store";
import {Store} from "@ngrx/store";
import {filter, first, switchMap} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {TypeFormAnswers} from "../../../add-website/typeFormAnswers";
import {GoogleAnalyticsService} from "../../services/google-analytics/google-analytics.service";
import {Router} from "@angular/router";
import {TypeUtils} from "../../utils/type-utils";
import {Config} from "../../../config/config";

@Component({
    selector: 'db-migration-steps',
    templateUrl: './migration-steps.component.html',
    styleUrls: ['./migration-steps.component.scss'],
    standalone: false
})
export class MigrationStepsComponent implements OnInit {

  private managerLink: string;
  public steps = [
    {title: 'Upload', desc: 'Upload the ZIP file to the plugins section of the WP admin of the website you want to migrate.', image: '../../../../assets/images/on-boarding/wp_admin_upload_plugin.jpg'},
    {title: 'Install & Activate', desc: 'Once installation is complete, activate the plugin. Migration of your website will start automatically.', image: '../../../../assets/images/on-boarding/activate_plugin.jpg'},
    {title: 'Test Migrated Website', desc: 'Test the copy of your website with a<br class="db-display-none-mobile"> 90+ PageSpeed score on 10Web Dashboard.', image: '../../../../assets/images/on-boarding/hosted_on_10web.jpg'},
  ];
  public agencyOrFreelancer: boolean;
  public typeFormAnswers = TypeFormAnswers;

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _router: Router,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {
    const user = this._route.snapshot.data['user'];
    this.agencyOrFreelancer = user.agencyOrFreelancer;

    this._store.select(fromStore.getTenWebProductsLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getTenWebManagerPlugin)),
        first()
      ).subscribe(managerPlugin => {
      this.managerLink = managerPlugin && managerPlugin.downloadLink;
    });
  }

  public downloadManagerPlugin(): void {
    this.downloadManagerPluginEvent();
    window.location.href = this.managerLink;
  }

  public downloadManagerPluginEvent(): void {
    const analyticsData = {
      eventCategory: 'Onboarding',
      eventAction: '10Web Manager Download',
      eventLabel: TypeUtils.isDefined(this._router) && TypeUtils.isDefined(this._router.url) ? this._router.url : 'migration-steps'
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }


  public toggleKnowLedgeBase() {
    this._store.dispatch(new fromStore.ToggleKnowledgeBase({articleId : 360021395000, scrollToEl: 'Automated 1-Click Migration'}));
  }

  public showEmbed() {
    const url = `${Config.typeFormUrl}${Config.typeFormSlackId}`;
    window['typeformEmbed'] !== 'undefined' && window['typeformEmbed'].makePopup(url, {
      mode: "drawer_top",
      hideHeaders: true,
      open: "load",
      onSubmit: function() {
        console.log("Typeform successfully submitted");
      },
    });
  }
}
